/**
 * Dictionary / language domain types shared by both apps.
 *
 * Original locations: (identical values, verified):
 *  - web: apps/web/src/types/dictionaries.ts (Dictionaries, brailleLanguageList)
 *         apps/web/src/store/queries/dictionaries/types.ts (SuggestedWordStatus)
 *         apps/web/src/pages/MyAccount/customDictionaries/customDictionaryUtils.ts (SortDirection)
 *  - api: apps/api/src/user-management/types/dictionaries.types.ts (Dictionaries)
 *         apps/api/src/dictionary/types/dictionary.types.ts (SuggestedWordStatus, SortDirection)
 */
/** Spellcheck dictionary language identifiers. Values are the human-readable display names. */
export var Dictionaries;
(function (Dictionaries) {
    Dictionaries["Arabic"] = "Arabic";
    Dictionaries["Bulgarian"] = "Bulgarian";
    Dictionaries["Catalan"] = "Catalan";
    Dictionaries["Croatian"] = "Croatian";
    Dictionaries["Czech"] = "Czech";
    Dictionaries["Danish"] = "Danish";
    Dictionaries["Dutch"] = "Dutch";
    Dictionaries["English_Canada"] = "English (Canada)";
    Dictionaries["English_Canada_Medical"] = "English (Canada) + Medical";
    Dictionaries["English_UK"] = "English (United Kingdom)";
    Dictionaries["English_UK_Medical"] = "English (United Kingdom) + Medical";
    Dictionaries["English_USA"] = "English (USA)";
    Dictionaries["English_USA_Medical"] = "English (USA) + Medical";
    Dictionaries["Estonian"] = "Estonian";
    Dictionaries["Finnish"] = "Finnish";
    Dictionaries["French"] = "French";
    Dictionaries["German"] = "German";
    Dictionaries["German_Austria"] = "German (Austria)";
    Dictionaries["German_Switzerland"] = "German (Switzerland)";
    Dictionaries["Greek"] = "Greek";
    Dictionaries["Hebrew"] = "Hebrew";
    Dictionaries["Hungarian"] = "Hungarian";
    Dictionaries["Indonesian"] = "Indonesian";
    Dictionaries["Irish"] = "Irish";
    Dictionaries["Italian"] = "Italian";
    Dictionaries["Japanese"] = "Japanese";
    Dictionaries["Korean"] = "Korean";
    Dictionaries["Latvian"] = "Latvian";
    Dictionaries["Lithuanian"] = "Lithuanian";
    Dictionaries["Maltese"] = "Maltese";
    Dictionaries["Norwegian_Bokmal"] = "Norwegian (Bokmal)";
    Dictionaries["Norwegian_Nynorsk"] = "Norwegian (Nynorsk)";
    Dictionaries["Polish"] = "Polish";
    Dictionaries["Portugese_Brazil"] = "Portuguese (Brazil)";
    Dictionaries["Portugese_Portugal"] = "Portuguese (Portugal)";
    Dictionaries["Romanian"] = "Romanian";
    Dictionaries["Russian"] = "Russian";
    Dictionaries["Serbian_Cyrillic"] = "Serbian (Cyrillic)";
    Dictionaries["Serbian_Latin"] = "Serbian (Latin)";
    Dictionaries["Slovak"] = "Slovak";
    Dictionaries["Slovenian"] = "Slovenian";
    Dictionaries["Spanish_Mexico"] = "Spanish (Mexico)";
    Dictionaries["Spanish_Spain"] = "Spanish (Spain)";
    Dictionaries["Swedish_Sweden"] = "Swedish (Sweden)";
    Dictionaries["Thai"] = "Thai";
    Dictionaries["Turkish"] = "Turkish";
    Dictionaries["Ukrainian"] = "Ukrainian";
})(Dictionaries || (Dictionaries = {}));
/** Approval state of a user-suggested custom dictionary word. */
export var SuggestedWordStatus;
(function (SuggestedWordStatus) {
    SuggestedWordStatus["PENDING"] = "PENDING";
    SuggestedWordStatus["APPROVED"] = "APPROVED";
    SuggestedWordStatus["REJECTED"] = "REJECTED";
})(SuggestedWordStatus || (SuggestedWordStatus = {}));
/** Sort direction for ordered dictionary list queries. */
export var SortDirection;
(function (SortDirection) {
    SortDirection["ASC"] = "asc";
    SortDirection["DESC"] = "desc";
})(SortDirection || (SortDirection = {}));
/** Braille translation languages offered in the braille language selector. */
export const brailleLanguageList = [
    { label: 'Albanian', value: 'Albanian' },
    { label: 'Basque (Spain)', value: 'Basque (Spain)' },
    { label: 'Belarusian', value: 'Belarusian' },
    { label: 'Bulgarian', value: 'Bulgarian' },
    { label: 'Catalan (Spain)', value: 'Catalan (Spain)' },
    { label: 'Croatian', value: 'Croatian' },
    { label: 'Czech', value: 'Czech' },
    { label: 'Danish', value: 'Danish' },
    { label: 'Dutch', value: 'Dutch' },
    { label: 'EBU', value: 'EBU' },
    { label: 'English (UK)', value: 'English (UK)' },
    { label: 'English', value: 'English' },
    { label: 'Estonian', value: 'Estonian' },
    { label: 'Faroese (Denmark)', value: 'Faroese (Denmark)' },
    { label: 'Finnish', value: 'Finnish' },
    { label: 'French (Antoine)', value: 'French (Antoine)' },
    { label: 'French (Traditional)', value: 'French (Traditional)' },
    { label: 'Galician (Spain)', value: 'Galician (Spain)' },
    { label: 'German', value: 'German' },
    { label: 'Greek', value: 'Greek' },
    { label: 'Greenlandic', value: 'Greenlandic' },
    { label: 'Hungarian', value: 'Hungarian' },
    { label: 'Icelandic', value: 'Icelandic' },
    { label: 'Irish (Gaelic)', value: 'Irish (Gaelic)' },
    { label: 'Italian', value: 'Italian' },
    { label: 'Kazakh', value: 'Kazakh' },
    { label: 'Latvian', value: 'Latvian' },
    { label: 'Lithuanian', value: 'Lithuanian' },
    { label: 'Maltese', value: 'Maltese' },
    { label: 'Norwegian', value: 'Norwegian' },
    { label: 'Polish', value: 'Polish' },
    { label: 'Portuguese', value: 'Portuguese' },
    { label: 'Romanian', value: 'Romanian' },
    { label: 'Russian', value: 'Russian' },
    { label: 'Serbian', value: 'Serbian' },
    { label: 'Slovakian', value: 'Slovakian' },
    { label: 'Slovene', value: 'Slovene' },
    { label: 'Spanish', value: 'Spanish' },
    { label: 'Swedish', value: 'Swedish' },
    { label: 'Turkish', value: 'Turkish' },
    { label: 'UEB', value: 'UEB' },
    { label: 'Ukrainian', value: 'Ukrainian' },
    { label: 'Uzbek', value: 'Uzbek' },
];
//# sourceMappingURL=dictionary.js.map